import { PaginationProps } from "../types";

export const Pagination = ({ totalPages, currentPage, onPageChange }: PaginationProps) => {
  const renderPageButtons = () => {
    const maxVisibleButtons = 5;

    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <button
          key={page}
          className={`pagination-button ${currentPage === page ? "active" : ""}`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ));
    }

    const pages: JSX.Element[] = [];

    pages.push(
      <button
        key={1}
        className={`pagination-button ${currentPage === 1 ? "active" : ""}`}
        onClick={() => onPageChange(1)}
      >
        1
      </button>,
    );

    let startPage = Math.max(2, currentPage - Math.floor(maxVisibleButtons / 2));
    const endPage = Math.min(totalPages - 1, startPage + maxVisibleButtons - 1);

    if (endPage - startPage < maxVisibleButtons - 1) {
      startPage = Math.max(2, endPage - maxVisibleButtons + 1);
    }

    if (startPage > 2) {
      pages.push(
        <span key="ellipsis-start" className="pagination-ellipsis">
          ...
        </span>,
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-button ${currentPage === i ? "active" : ""}`}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>,
      );
    }

    if (endPage < totalPages - 1) {
      pages.push(
        <span key="ellipsis-end" className="pagination-ellipsis">
          ...
        </span>,
      );
    }

    pages.push(
      <button
        key={totalPages}
        className={`pagination-button ${currentPage === totalPages ? "active" : ""}`}
        onClick={() => onPageChange(totalPages)}
      >
        {totalPages}
      </button>,
    );

    return pages;
  };

  return (
    <div className="pagination-container">
      <div className="pagination-wrapper">
        <button
          className="pagination-button"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
        >
          &lt; Prev
        </button>

        <div className="pagination-buttons">{renderPageButtons()}</div>

        <button
          className="pagination-button"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
        >
          Next &gt;
        </button>
      </div>
    </div>
  );
};
